import { create } from "zustand";
import { persist } from "zustand/middleware";

export type IntervalSize = "weeks" | "months" | "quarters" | "years";

export type HistoryStore = {
  backCount: number;
  intervalSize: IntervalSize;
  onlyNights: boolean;
  timeInBed: number;
  timeAsleep: number;
  setBackCount: (backCount: number) => void;
  setIntervalSize: (intervalSize: IntervalSize) => void;
  setOnlyNights: (onlyNights: boolean) => void;
  setTimeInBed: (timeInBed: number) => void;
  setTimeAsleep: (timeAsleep: number) => void;
};

export const useHistoryStore = create<HistoryStore>()(
  persist(
    (set) => ({
      backCount: 0,
      intervalSize: "weeks",
      onlyNights: true,
      timeInBed: 120,
      timeAsleep: 120,
      setIntervalSize: (intervalSize) =>
        set((s) => ({ ...s, backCount: 0, intervalSize })),
      setBackCount: (backCount) => set((s) => ({ ...s, backCount })),
      setOnlyNights: (onlyNights) => set((s) => ({ ...s, onlyNights })),
      setTimeInBed: (timeInBed) => set((s) => ({ ...s, timeInBed })),
      setTimeAsleep: (timeAsleep) => set((s) => ({ ...s, timeAsleep })),
    }),
    {
      name: "subject-history-store",
    },
  ),
);
